import React from "react";

const Loader = props => (
  <div className="afd-story afd-story--loading" />
);

export default Loader;
